/* eslint-disable import/no-anonymous-default-export */
import Error404 from './pages/error/error404';
import Error500 from './pages/error/error500';
import Home from './pages/home';
import Login from './pages/login';
import Ours from './pages/ours';
import HowHelp from './pages/howHelp';
import Contact from './pages/contact';
import ApplicationForm from './pages/applicationForm';
import VolunteerForm from './pages/volunteerForm';
import Policy from './pages/policy';
import Blog from './pages/blog';

export default [
  {
    id: 'home',
    path: '',
    index: true,
    component: Home,
    icon: '',
  },
  {
    id: 'login',
    path: 'login',
    component: Login,
    icon: '',
  },
  {
    id: 'ours',
    path: 'ours',
    component: Ours,
    icon: '',
  },
  {
    id: 'howHelp',
    path: 'howHelp',
    component: HowHelp,
    icon: '',
  },
  {
    id: 'contact',
    path: 'contact',
    component: Contact,
    icon: '',
  },
  {
    id: 'applicationForm',
    path: 'applicationForm',
    component: ApplicationForm,
    icon: '',
  },
  {
    id: 'volunteerForm',
    path: 'volunteerForm',
    component: VolunteerForm,
    icon: '',
  },
  {
    id: 'error404',
    path: '404',
    component: Error404,
    icon: '',
  },
  {
    id: 'error500',
    path: '500',
    component: Error500,
    icon: '',
  },
  {
    id: 'policy',
    path: 'policy',
    component: Policy,
    icon: '',
  },
  {
    id: 'blog',
    path: 'blog',
    component: Blog,
    icon: '',
  },
];
